<template>
  <div class='condition-curved' v-if="!this.isUSTWall">
    <div class="curved_container">
      <div v-if="blendingParam.shapeShow !== '2'">
        <div class="img-container">
          <!-- 半径 -->
          <div class='curved_radius'>
            <div class="span_unit_container">
              <span>{{$t('T_CURVE_RADIUS')}}</span>
            </div>
            <span class="" v-if="isFraction">
              <FtInput v-model="radius_input" :unitData="unit" @blur='changeMutation("radius_input", "SET_BLENDING_RADIUS")'></FtInput>
            </span>
            <div class="input_unit_container" v-else>
              <inputValidateBox prop='radius_input' :rules="rules.number">
                <el-input v-model='radius_input' @input="testDigital($event, 'radius_input')" class='roomsize_input'
                  @blur='changeMutation("radius_input", "SET_BLENDING_RADIUS")'
                  @keyup.enter.native='changeMutation("radius_input", "SET_BLENDING_RADIUS")'>
                </el-input>
                <span class='m'>{{blendingUnitLabel}}</span>
              </inputValidateBox>
            </div>
          </div>
          <div class="curved-img">
            <el-image :src="imgUrl" fit="fit"></el-image>
          </div>
          <!-- 中心角 弧度 深度 -->
          <div class='curved_select_container'>
            <div class="curved_select">
              <el-select v-model="curveSelect">
                <el-option v-for="item in curveSelectOptions" :key='item.value' :label='$t(item.label)'
                  :value='item.value'>
                </el-option>
              </el-select>
            </div>
            <div class="select_span_container ellipsis">
              <!-- 中心角 -->
              <div v-if="curveSelect === '0'">
                <el-input v-model='central_angle_input' class='roomsize_input'
                  @input="testDigital($event, 'central_angle_input')"
                  @blur='onCentralAngleChange(central_angle_input)'
                  @keyup.enter.native="onCentralAngleChange(central_angle_input)">
                </el-input>
                <span class='m'>{{$t('T_CURVE_DEGREE')}}</span>
              </div>
              <!-- 弧长 -->
              <div v-if="curveSelect === '1'">
                <div class="ft_inch_item ft_inch_item-wdith" v-if="isFraction">
                  <FtInput v-model="arc_input" :unitData="unit" @blur='changeMutation("arc_input")' :forceUpdate='forceUpdate'></FtInput>
                </div>
                <inputValidateBox  prop='arc_input' :rules=" rules.number" v-else>
                  <el-input v-model='arc_input' class='roomsize_input'
                    @input="testDigital($event, 'arc_input')"
                    @blur='changeMutation("arc_input")'
                    @keyup.enter.native='changeMutation("arc_input")'>
                  </el-input>
                  <span class="m">{{blendingUnitLabel}}</span>
                </inputValidateBox>
              </div>

              <!-- 深度 -->
              <div v-if="curveSelect === '2'">
                <div class="ft_inch_item ft_inch_item-wdith" v-if="isFraction">
                  <FtInput v-model="depth_input" :unitData="unit"  @blur='changeMutation("depth_input")' :forceUpdate='forceUpdate'></FtInput>
                </div>
                <inputValidateBox  prop='depth_input' :rules="rules.number" v-else>
                  <el-input v-model='depth_input' class='roomsize_input'
                    @input="testDigital($event, 'depth_input')"
                    @blur='changeMutation("depth_input")'
                    @keyup.enter.native='changeMutation("depth_input")'>
                  </el-input>
                  <span class="m">{{blendingUnitLabel}}</span>
                </inputValidateBox>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="pj_position">
      <div class="screen_height">
        <span>{{$t('T_SCREEN_HEIGHT')}}</span>
        <div class="height_fraction" v-if="isFraction">
          <FtInput v-model="screen_height_input" :unitData="unit" @blur='screenHeightChange'></FtInput>
        </div>
        <div class="screen_height_input" v-else>
          <inputValidateBox prop='screen_height_input' :rules="rules.number">
            <el-input v-model='screen_height_input' @input="testDigital($event, 'screen_height_input')" @change="screenHeightChange" class='roomsize_input'>
            </el-input>
            <span class='m'>{{blendingUnitLabel}}</span>
          </inputValidateBox>
        </div>
      </div>

      <div class="screen_height_img">
        <el-image :src="require('@/assets/parts/blending/screen_heignt_lens_height.png')" fit="fit"></el-image>
      </div>

      <div class="lens_height" :class="{lens_height_fraction: isFraction}">
        <span>{{$t('T_LENS_HEIGHT')}}</span>
        <div class="height_fraction" v-if="isFraction">
          <FtInput v-model="lens_height_input" :unitData="unit" @blur='lensHeightChange' :forceUpdate="forceUpdate"></FtInput>
        </div>
        <div class="lens_height_input" v-else>
          <inputValidateBox prop='lens_height_input' :rules="rules.number">
            <el-input v-model='lens_height_input' @input="testDigitalNegative($event, 'lens_height_input')" @change="lensHeightChange" class='roomsize_input'>
            </el-input>
            <span class='m'>{{blendingUnitLabel}}</span>
          </inputValidateBox>
        </div>
        <div class="lens_height_range">({{lens_height_min}}~ {{lens_height_max}}{{blendingUnitLabel}})</div>
      </div>

    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import inputValidateBox from '@/components/inputValidateBox'
import { EventBus } from '@/common/event-bus.js'
import FtInput from '@/components/ftInput'

export default {
  components: {inputValidateBox, FtInput},
  name: 'blendingCurveCondition',
  props: ['angleActive', 'ambientActive', 'unit'],
  data () {
    return {
      curveSelectOptions: [
        {
          value: '0',
          label: 'T_CURVE_ANGLE'
        }, {
          value: '1',
          label: 'T_CURVE_ARC'
        }, {
          value: '2',
          label: 'T_CURVE_DEPTH'
        }
      ],
      curveSelect: '0',
      radius_input: '0',
      central_angle_input: 0,
      arc_input: '0',
      depth_input: '0',
      blendingArc: 0,
      blendingDepth: 0,
      screen_height_input: '0',
      lens_height_input: '0',
      currentRatio: '16:10',
      // lens_height_min: 91,
      // lens_height_range: {
      //   min: 91,
      //   max: 259
      // },
      rules: {
        'number': [
        ],
        'numberValid': [
          // {required: true, message: 'T_ALERT_DISPLAY_INPUT_NEED'},
          {pattern: /^\d+\.\d+$|\\+$|"+$/g}
        ]
      },
      screenAngle: 0,
      blendingRadius: 0,
      forceUpdate: false
    }
  },
  computed: {
    ...mapState([
      'graph',
      'isUSTWall',
      'isOutOfSpec',
      'blendingParam',
      'vLensShiftNow',
      'selectedLensData',
      'blendingUnit'
    ]),
    ...mapGetters([
      'blendingUnitLabel'
    ]),
    isFraction () {
      return this.unit === 'T_FEET_FRACTION' || this.unit === 'T_INCH_FRACTION'
    },
    // unit () {
    //   return this.blendingUnit
    // },
    // blendingRadius() {
    //   return this.blendingParam.radius
    // },
    central_angle () { // 角度制
      return (180 * this.screenAngle / Math.PI).toFixed(1)
    },
    imgUrl () {
      let url
      // shapeShow: '2', // '0':凹面, '1':凸面, '2': 平面,
      if (this.blendingParam.shapeShow === '0') { // 凹面水平
        switch (this.curveSelect) {
          case '0':// 中心角
            url = 'concaveLevel_Angle.png'
            break
          case '1':
            url = 'concaveLevel_Arc.png'
            break
          case '2':
            url = 'concaveLevel_Depth.png'
            break
          default:
            break
        }
      }

      if (this.blendingParam.shapeShow === '1') { // 凸面水平
        switch (this.curveSelect) {
          case '0':// 中心角
            url = 'convexLevel_Angle.png'
            break
          case '1':
            url = 'convexLevel_Arc.png'
            break
          case '2':
            url = 'convexLevel_Depth.png'
            break
          default:
            break
        }
      }
      return require('@/assets/parts/curvedSurface/' + url)
    },
    lens_height_min () {
      return this.$commonJs.changeUnit(this.lens_height_range.min, this.unit, false)
    },
    lens_height_max () {
      return this.$commonJs.changeUnit(this.lens_height_range.max, this.unit, false)
    },
    lens_height_range () {
      // let lh = this.$commonJs.changeUnit(this.lens_height_input, this.unit, true)
      let height = this.$commonJs.changeUnit(this.screen_height_input, this.unit, true)
      let size = (this.$commonViewJs.getScreenSizeByCalY(height, this.currentRatio)).size
      let dis = this.$commonViewJs.calScreensizeRatioToDistanceBlendingWide(size, this.currentRatio)
      let initScreen = this.$commonViewJs.getInitScreenXyFromDist(dis)
      let min = 0
      let max = 0
      let lensShiftData = this.selectedLensData.lcd.lensShiftRange

      if (this.blendingParam.position !== '1') {
        min = height / 2 - initScreen.calY * lensShiftData.v.max
        max = height / 2 - initScreen.calY * lensShiftData.v.min
      } else {
        max = height / 2 + initScreen.calY * lensShiftData.v.max
        min = height / 2 + initScreen.calY * lensShiftData.v.min
      }
      // if (this.blendingParam.position === '0') {
      //   min = height / 2 - initScreen.calY * this.graph.vLensShift.max
      //   max = height / 2 - initScreen.calY * this.graph.vLensShift.min
      // } else {
      //   max = height / 2 + initScreen.calY * this.graph.vLensShift.max
      //   min = height / 2 + initScreen.calY * this.graph.vLensShift.min
      // }
      // if (lh > max || lh < min) {
      //   lh = lh > max ? max : (lh < min ? min : lh)
      //   // this.lens_height_input = this.$commonJs.changeUnit(lh, this.unit, false)
      // }
      return {'min': min, 'max': max}
    },

    screenHeight () {
      return this.blendingParam.screenHeight
    },

    lensHeight () {
      return this.blendingParam.lensHeight
    },

    angle () {
      return this.blendingParam.angle
    }

  },
  watch: {
    unit (newValue, oldValue) {
      this.radius_input = this.$commonJs.changeUnit(this.blendingRadius, newValue, false)
      this.depth_input = this.$commonJs.changeUnit(this.blendingDepth, newValue, false)
      this.arc_input = this.$commonJs.changeUnit(this.blendingArc, newValue, false)
      this.screen_height_input = this.$commonJs.changeUnit(this.blendingParam.screenHeight, newValue, false)
      this.lens_height_input = this.$commonJs.changeUnit(this.blendingParam.lensHeight, newValue, false)
    },
    central_angle (newValue, oldValue) {
      this.central_angle_input = newValue
    },

    blendingRadius (newValue, oldValue) {
      this.radius_input = this.$commonJs.changeUnit(newValue, this.unit, false)
    },

    screenHeight (newValue, oldValue) {
      this.screen_height_input = this.$commonJs.changeUnit(newValue, this.unit, false)
    },

    lensHeight (newValue, oldValue) {
      this.lens_height_input = this.$commonJs.changeUnit(newValue, this.unit, false)
    },

    angle (newValue, oldValue) {
      this.screenAngle = newValue
    },
    selectedLensData (newValue, oldValue) {
      this.lensHeightChange(this.lens_height_input)
    },
    lens_height_range (newValue, oldValue) {
      this.lensHeightChange(this.lens_height_input)
    }

  },
  methods: {
    ...mapMutations([
      'SET_BLENDING_CURVESELECT',
      'SET_BLENDING_RADIUS',
      'SET_BLENDING_ANGLE',
      'SET_BLENDING_DEPTH',
      'SET_BLENDING_ARC',
      'SET_BLENDING_SCREENHEIGHT',
      'SET_BLENDING_LENSHEIGHTRATE_MIN',
      'SET_BLENDING_LENSHEIGHTRATE_MAX',
      'SET_BLENDING_LENSHEIGHT']),
    testDigital (e, key) {
      e = e.replace(/[^0-9|.]/ig, '')
      let n = (this[key].split('.') || []).length - 1
      if (n > 1) {
        e = ''
      }
      this[key] = e
    },
    testDigitalNegative (e, key) {
      e = e.replace(/[^(\-|+)0-9|.]/ig, '')
      if (e !== '-') {
        this[key] = e || ''
      } else {
        this[key] = e
      }
    },

    screenHeightChange (value) {
      if (!this.isFraction && isNaN(this.screen_height_input)) this.screen_height_input = '0'
      if (!this.isFraction) {
        this.screen_height_input = this.screen_height_input * 1
      }
      var temp = this.$commonJs.changeUnit(this.screen_height_input, this.unit, true)
      this.screen_height_input = this.$commonJs.changeUnit(temp, this.unit, false)
      this.lensHeightChange(this.lens_height_input)
    },
    /**
     * 对页面字段lens Height进行校验，在默认范围内
     */
    lensHeightChange (value) {
      this.forceUpdate = false
      this.$nextTick(() => {
        if (this.isFraction) {
          this.forceUpdate = true
        }
        let lensH = 0
        if (this.unit !== 'T_FEET_FRACTION' && this.unit !== 'T_INCH_FRACTION') {
          if (isNaN(Number(value)) || Number(value) === 0) {
            lensH = 0
          } else {
            lensH = this.$commonJs.changeUnit(value, this.unit, true)
          }
        } else {
          lensH = this.$commonJs.changeUnit(value, this.unit, true)
        }
        let lensMin = this.lens_height_range.min
        let lensMax = this.lens_height_range.max
        if (lensH > lensMax) {
          lensH = lensMax
        } else if (lensH < lensMin) {
          lensH = lensMin
        }
        this.lens_height_input = this.$commonJs.changeUnit(lensH, this.unit, false)
      })
    },
    changeMutation (key, mutationKey, callBack, args = '') {
      this.forceUpdate = false
      this.$nextTick(() => {
        if (!this.isFraction && (isNaN(this[key]) || this[key] === '')) this[key] = '0'
        let temp = this.$commonJs.changeUnit(this[key], this.unit, true)
        if (key === 'arc_input') {
          temp = this.$commonJs.checkRange(temp, 0, 2 * Math.PI * this.blendingRadius)
        }
        if (key === 'depth_input') {
          temp = this.$commonJs.checkRange(temp, 0, 2 * this.blendingRadius)
        }
        this[key] = this.$commonJs.changeUnit(temp, this.unit, false)
        // if (mutationKey) {
        //   this[mutationKey](temp)
        // }
        if (this.isFraction) {
          this.forceUpdate = true
        }
        if (key === 'radius_input') {
          this.blendingRadius = temp
          if (this.curveSelect === '0') {
            this.arc_input = this.radiusAndAngleToArc(this.screenAngle)
            this.depth_input = this.radiusAndAngleToDepth(this.screenAngle)
          } else if (this.curveSelect === '1') {
            this.screenAngle = this.radiusAndArcToAngle(this.blendingArc)
            this.depth_input = this.radiusAndArcToDepth(this.blendingArc)
          } else {
            let angle = this.radiusAndDepthToAngle(this.blendingDepth)
            this.screenAngle = angle
            this.arc_input = this.radiusAndDepthToArc(angle)
          }
        }

        if (key === 'arc_input') {
          this.blendingArc = temp
          this.screenAngle = this.radiusAndArcToAngle(temp)
          this.depth_input = this.radiusAndArcToDepth(temp)
        }
        if (key === 'depth_input') {
          this.blendingDepth = temp
          let angle = this.radiusAndDepthToAngle(temp)
          // this.SET_BLENDING_ANGLE(angle)
          this.screenAngle = angle
          this.arc_input = this.radiusAndDepthToArc(angle)
        }
      })
    },
    changeCurveParm () {
      this.SET_BLENDING_CURVESELECT(this.curveSelect)
      this.SET_BLENDING_ANGLE(this.screenAngle)
      this.SET_BLENDING_DEPTH(this.$commonJs.changeUnit(this.depth_input, this.unit, true))
      this.SET_BLENDING_ARC(this.$commonJs.changeUnit(this.arc_input, this.unit, true))
      this.SET_BLENDING_RADIUS(this.$commonJs.changeUnit(this.radius_input, this.unit, true))
      this.SET_BLENDING_SCREENHEIGHT(this.$commonJs.changeUnit(this.screen_height_input, this.unit, true))
      this.SET_BLENDING_LENSHEIGHT(this.$commonJs.changeUnit(this.lens_height_input, this.unit, true))
      this.SET_BLENDING_LENSHEIGHTRATE_MIN(this.lens_height_range.min)
      this.SET_BLENDING_LENSHEIGHTRATE_MAX(this.lens_height_range.max)
    },
    onCentralAngleChange (num) {
      if (isNaN(num)) num = '0'
      let value = Number(num)
      let val = value > 360 ? 360 : value
      let angle = val * Math.PI / 180
      // this.SET_BLENDING_ANGLE(angle)
      this.screenAngle = angle
      this.central_angle_input = this.central_angle
      this.arc_input = this.radiusAndAngleToArc(angle)
      this.depth_input = this.radiusAndAngleToDepth(angle)
    },
    radiusAndAngleToArc (angle) {
      this.blendingArc = this.blendingRadius * angle
      return this.$commonJs.changeUnit(this.blendingArc, this.unit, false)
    },
    radiusAndAngleToDepth (angle) {
      this.blendingDepth = this.blendingRadius - this.blendingRadius * Math.cos(angle / 2)
      return this.$commonJs.changeUnit(this.blendingDepth, this.unit, false)
    },
    radiusAndArcToAngle (arc) {
      let value = arc / this.blendingRadius
      return value
    },
    radiusAndArcToDepth (arc) {
      // this.blendingDepth = this.blendingRadius - this.blendingRadius * Math.cos(this.central_angle_input / 2)
      let centang2 = arc / (2 * this.blendingRadius)
      let apo = Math.cos(centang2) * this.blendingRadius
      this.blendingDepth = this.blendingRadius - apo

      return this.$commonJs.changeUnit(this.blendingDepth, this.unit, false)
    },

    radiusAndDepthToAngle (depth) {
      let length = this.blendingRadius - depth
      let chord = 2 * Math.sqrt(Math.pow(this.blendingRadius, 2) - Math.pow(length, 2))
      let value = 2 * Math.atan((chord / 2) / length)
      let angle = value <= 0 ? value + Math.PI * 2 : value
      return angle
    },
    radiusAndDepthToArc (angle) {
      this.blendingArc = this.blendingRadius * angle
      return this.$commonJs.changeUnit(this.blendingArc, this.unit, false)
    },
    rejeLensHeight () {
      let height = this.$commonJs.changeUnit(this.screen_height_input, this.unit, true)
      let size = (this.$commonViewJs.getScreenSizeByCalY(height, this.currentRatio)).size
      let dis = this.$commonViewJs.calScreensizeRatioToDistanceBlendingWide(size, this.currentRatio)
      let initScreen = this.$commonViewJs.getInitScreenXyFromDist(dis)
      let h = initScreen.calY * this.vLensShiftNow / 100 + height / 2
      this.lens_height_input = this.$commonJs.changeUnit(h, this.unit, false)
    }

  },
  mounted () {
    this.curveSelect = this.blendingParam.curveSelect
    this.screenAngle = this.blendingParam.angle
    this.blendingRadius = this.blendingParam.radius
    this.blendingDepth = this.blendingParam.depth
    this.blendingArc = this.blendingParam.arc
    this.currentRatio = this.blendingParam.ratio
    this.radius_input = this.$commonJs.changeUnit(this.blendingRadius, this.unit, false)
    this.depth_input = this.$commonJs.changeUnit(this.blendingDepth, this.unit, false)
    this.arc_input = this.$commonJs.changeUnit(this.blendingArc, this.unit, false)
    this.central_angle_input = this.central_angle
    this.screen_height_input = this.$commonJs.changeUnit(this.blendingParam.screenHeight, this.unit, false)
    this.lens_height_input = this.$commonJs.changeUnit(this.blendingParam.lensHeight, this.unit, false)
    EventBus.$on('changeCurveParm', () => {
      this.changeCurveParm()
    })
    EventBus.$on('currentRatioChange', (ratio) => {
      this.currentRatio = ratio
    })
    EventBus.$on('changePosition', () => {
      this.rejeLensHeight()
    })
  }
}
</script>
<style scoped>
  .condition-curved{
    height: 200px;
    font-size: 13px;
    margin-top: 10px;
  }
  .select_container {
    float: right;
    width: 140px;
    margin-right: 34px;
  }
  .span_container {
    float: left;
    width: 148px;
  }
  .select_span_container {
    float: left;
  }
  .span_unit_container {
    float: left;
    margin-right: 10px;
  }
  .input_unit_container {
    display: flex;
    float: left;
  }
  .curved_select{
    float: left;
    width: 110px;
    margin-right: 9px;
  }
  .curved_container{
    float: left;
    margin-left: 50px;
  }
  .img-container{
    position: relative;
    background: #ffffff;
    height: 200px;
    margin: 0 10px
  }
  .curved-img{
    height: 200px;
    width: 322px;
  }
  .curved_radius{
    position: absolute;
    top: 1px;
    right: 0;
    background:#f3f3f2;
    z-index: 20
  }
  .curved_radius{
    padding: 3px 10px;
    line-height: 26px;
  }
  .curved_depth,
  .curved_angle {
    padding: 0px 10px 5px;
    line-height: 26px;
  }
  .curved_select_container{
    position: absolute;
    bottom: 0;
    right: 0;
    line-height: 26px;
    background: #f3f3f2;
    padding: 3px 6px 1px 10px;
  }
  .pj_position{
    height: 200px;
    float: right;
    padding-top: 40px;
    margin-right: 100px;
  }
  .screen_height,
  .screen_height_img,
  .lens_height{
    float: left;
  }
  .screen_height{
    padding: 5px 10px;
    background: #f3f3f2;
    margin: 30px 10px 0 0;

  }
  .screen_height_input,
  .lens_height_input{
    display: inline-block;
    margin-left: 10px;
  }
  .lens_height{
    height: 60px;
    padding: 5px 10px;
    background: #f3f3f2;
    margin: 50px 10px 0 -35px;
    position: relative;
  }
  .lens_height_range{
    white-space: nowrap;
    position: absolute;
    color: #999999;
    right: 0px;
    margin-top: 5px;
  }
  .height_fraction{
    margin-top: 5px
  }
  .lens_height_fraction{
    height: 80px;
    top:-12px
  }
</style>



// WEBPACK FOOTER //
// src/view/searchTabs/blendingCurveCondition.vue